import { Route } from '@angular/router';
import { PoolEditComponent } from 'src/app/pages/network/pool-edit/pool-edit.component';
import { PoolsComponent } from 'src/app/pages/network/pools/pools.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const pools: Route = {
  path: 'pools',
  title: 'nav.network.pools',
  data: {
    breadcrumb: 'nav.network.pools',
    icon: SbIcons.pools,
    id: RoutingID.pools,
  },
  children: [
    {
      path: '',
      component: PoolsComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'pool-edit/:poolID',
      title: 'nav.network.pools.editPool',
      data: {
        breadcrumb: 'nav.network.pools.editPool',
        icon: SbIcons.edit,
        id: RoutingID.poolEdit,
      },
      children: [
        {
          path: '',
          component: PoolEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'pool-create',
      title: 'nav.network.pools.createPool',
      data: {
        breadcrumb: 'nav.network.pools.createPool',
        icon: SbIcons.plus,
        id: RoutingID.poolCreate,
      },
      children: [
        {
          path: '',
          component: PoolEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
